/**
 * Owner: Masa Bayu
 * File: QxWriterEditor.tsx
 * Date:Time: 2026-10-07 01:35
 * Description: EM-FIX-01 · standalone Lexical · optional absolute placement.
 */

import type { ReactElement } from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { QxWriterEditorBody } from './QxWriterEditorBody';
import { getEditorConfig } from './qx-writer-editor';
import { getEditorTheme } from './qx-writer-theme';
import type { StructuredPage } from '../types';
import './qxw-theme.css';

export interface QxWriterEditorProps {
  readonly page: StructuredPage;
  /** EM-FIX-01 · paint paragraphs at witnessed bbox. */
  readonly absolutePlacement?: boolean;
}

export function QxWriterEditor(props: QxWriterEditorProps): ReactElement {
  const { page, absolutePlacement = false } = props;
  const base = getEditorConfig();

  return (
    <div
      className="qxw-shell"
      data-qxw-writer-editor=""
      data-qx-editor-root="standalone"
      data-em-absolute={absolutePlacement ? '1' : undefined}
      style={
        absolutePlacement
          ? { position: 'relative', width: '100%', height: '100%' }
          : undefined
      }
    >
      <LexicalComposer
        initialConfig={{
          namespace: base.namespace,
          nodes: base.nodes,
          onError: base.onError,
          theme: getEditorTheme(),
        }}
      >
        <QxWriterEditorBody
          page={page}
          absolutePlacement={absolutePlacement}
        />
      </LexicalComposer>
    </div>
  );
}
